import { TierNameValue } from "@ugg/shared/utils/tier-helpers";
import {
  TIER_CARD_ACCENT_BG,
  TIER_CARD_BANNER_CLASSES,
  TIER_CARD_BODY_BG,
} from "@ugg/shared/components/TierList/common/tier-card-styles";

// ─────────────────────────────────────────────────────────────────────
// One tier group in a stacked custom-mode tier list: a colored banner
// carrying the tier letter, a 1px divider, and a responsive grid of
// cells underneath.
//
// Extracted from three byte-identical copies — the ARAM Mayhem champion
// table, the ARAM Mayhem augment rows, and the Classic champion table.
// Only the cell contents differed, so those are `children`.
// ─────────────────────────────────────────────────────────────────────

interface TierGroupCardProps {
  tier: TierNameValue;
  children: React.ReactNode;
}

export function TierGroupCard({ tier, children }: TierGroupCardProps) {
  return (
    <section aria-label={`Tier ${tier}`} className="overflow-hidden rounded-[3px]">
      <div
        className={`flex h-14 items-center gap-3 border-l-4 bg-[#191937] bg-gradient-to-r to-transparent px-[18px] ${TIER_CARD_BANNER_CLASSES[tier]}`}
      >
        <span className={`block h-5 w-0.5 rounded-sm ${TIER_CARD_ACCENT_BG[tier]}`} aria-hidden="true" />
        <h2 className="text-sm font-bold text-white">{tier}</h2>
      </div>
      <div className={`h-px ${TIER_CARD_ACCENT_BG[tier]}`} aria-hidden="true" />
      <div
        className={`grid grid-cols-1 gap-x-[18px] gap-y-[18px] border-l-4 p-[18px] sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 ${TIER_CARD_BODY_BG[tier]} ${TIER_CARD_BANNER_CLASSES[tier]}`}
      >
        {children}
      </div>
    </section>
  );
}
